import { LinearProgress } from "@material-ui/core";
import { useEffect, useState } from "react";
import { pStatus } from "../utils/parameters";
import { useVideo } from './VideoProvider'

export function VideoTimer() {
    const [ctr, setCtr] = useState(10)

    const { recTime, faceStatus, setFaceStatus } = useVideo();

    /* Update total time */
    useEffect(() => {
        setCtr(recTime)
    }, [recTime])

    /* 1s timer */
    useEffect(() => {
        let timer;

        /* Recording */
        if (ctr > 0 && faceStatus === pStatus.record) {
            timer = setTimeout(() => setCtr(ctr - 1), 1000);
        }
        /* End of recording: stop and show repetition */
        else if (ctr === 0) {
            timer = setTimeout(() => setCtr(ctr - 1), 1000);
            setFaceStatus(pStatus.rep);
        }
        /* Reset timer */
        else if (ctr < 0) {
            setCtr(recTime)
        }

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [ctr, recTime, faceStatus, setFaceStatus]);

    return (
        <LinearProgress className='sig_Home_Progress' variant="determinate" value={100 * ctr / recTime} />
    )
}